import {
	IconAtom2Outline18 as Atom,
	IconBanOutline18 as Ban,
	IconUsersOutline18 as Users,
} from "nucleo-ui-outline-18"

import type { ToolAccess } from "@productlane/lib/src/browser"
import type { SegmentedControlOption } from "@productlane/ui"
import { SegmentedControl } from "@productlane/ui"

export const TOOL_ACCESS_OPTIONS: readonly SegmentedControlOption<ToolAccess>[] =
	[
		{
			value: "agent",
			label: "Agent and team",
			description: "The agent and your team's AI can use it.",
			Icon: Atom,
		},
		{
			value: "team",
			label: "Team only",
			description: "Only the AI Assistant and reviewed drafts use it.",
			Icon: Users,
		},
		{
			value: "off",
			label: "Off",
			description: "No AI can use it.",
			Icon: Ban,
		},
	]

// An HTTP connector has no "off": drafts and the AI Assistant always read it.
export const HTTP_ACCESS_OPTIONS = TOOL_ACCESS_OPTIONS.filter(
	(option) => option.value !== "off",
)

const GROUP_DESCRIPTION = "Sets every action in this group."

export const GROUP_ACCESS_OPTIONS: readonly SegmentedControlOption<ToolAccess>[] =
	TOOL_ACCESS_OPTIONS.map((option) => ({
		...option,
		description: GROUP_DESCRIPTION,
	}))

export function AccessControl({
	name,
	label,
	value,
	options = TOOL_ACCESS_OPTIONS,
	onChange,
}: {
	name: string
	label: string
	value: ToolAccess | null
	options?: readonly SegmentedControlOption<ToolAccess>[]
	onChange: (access: ToolAccess) => void
}) {
	return (
		<SegmentedControl
			name={name}
			aria-label={label}
			value={value}
			options={options}
			onValueChange={onChange}
		/>
	)
}
